import axios from "@/plugins/axios";

let url = "/api/v1/uthestar/campaigns";

export const campaigns = {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
}